import 'rxjs/add/observable/fromPromise';
import { GamesService } from '@app/core/games.service';
import { Router } from '@angular/router';
var GuideService = /** @class */ (function () {
    function GuideService(gamesVariables, router) {
        this.gamesVariables = gamesVariables;
        this.router = router;
        this._currentGameSections = [];
    }
    Object.defineProperty(GuideService.prototype, "defineGame", {
        set: function (game) {
            this._currentGame = game;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GuideService.prototype, "defineSections", {
        set: function (sections) {
            this._currentGameSections = sections;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GuideService.prototype, "fetchSections", {
        get: function () {
            return this._currentGameSections;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GuideService.prototype, "fetchGame", {
        get: function () {
            return this._currentGame;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GuideService.prototype, "getCurrentGameVisibility", {
        get: function () {
            if (!!this.visibility) {
                return this.visibility[this._currentGame];
            }
            return false; // If something went wrong don't show modal
        },
        enumerable: true,
        configurable: true
    });
    GuideService.prototype.setVisibilityToCurrentGame = function (value) {
        if (!!this.visibility) {
            this.visibility[this._currentGame] = value;
            localStorage.setItem('edg-rules-visibility', JSON.stringify(this.visibility));
        }
    };
    GuideService.prototype.showModal = function (gameName, sections) {
        this.defineGame = gameName;
        this.fetchAllGamesVisibilities();
        if (this.getCurrentGameVisibility) {
            this.defineSections = sections;
            this.router.navigate(['/', { outlets: { modal: 'game-rules' } }]);
        }
    };
    GuideService.prototype.fetchAllGamesVisibilities = function () {
        var data = localStorage.getItem('edg-rules-visibility');
        if (!data) {
            var obj_1 = {};
            this.gamesVariables.gamesList.forEach(function (game) {
                obj_1[game] = true;
            });
            localStorage.setItem('edg-rules-visibility', JSON.stringify(obj_1));
            this.visibility = obj_1;
        }
        else {
            this.visibility = JSON.parse(data);
        }
    };
    return GuideService;
}());
export { GuideService };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/services/guide.service.ts.pre-build-optimizer.js